import { Paths } from "../constants/UrlConstants";
import { InboxPages } from "../constants/Constants";

const UploadDocumentSmartLink = {
  linkText: "Upload a document",
  pathTo: `${Paths.MessageCentre}?page=${InboxPages.GeneralQuery}`,
  iconName: "icon-functional-upload"
};

export default UploadDocumentSmartLink;
